module.exports = __webpack_public_path__ + "img/deafened.bc906ca4.svg";